import React from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import styles from './styles'

const Drawer = ({ children, isActive, hideDrawer, css, overlayCss }) => {
  return (
    <>
      <div
        css={[
          styles.overlay,
          overlayCss,
          isActive ? styles.overlayActive : styles.overlayDisabled,
        ]}
        onClick={hideDrawer}
      />
      <div
        css={[
          styles.drawer,
          css,
          isActive ? styles.drawerActive : styles.drawerDisabled,
        ]}
      >
        <FontAwesomeIcon
          icon="caret-right"
          css={styles.closeButton}
          onClick={hideDrawer}
        />
        {children}
      </div>
    </>
  )
}

Drawer.propTypes = {
  children: PropTypes.node.isRequired,
  isActive: PropTypes.bool,
  hideDrawer: PropTypes.func,
  css: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  overlayCss: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
}

export default Drawer
